export default __webpack_public_path__ + "static/media/Omnisource_PRIVACY_POLICY.3ec470dd.pdf";